import React, { useState } from 'react'
import {
  DialogContentText,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
} from '@material-ui/core'
import PropTypes from 'prop-types'
import { Translate } from 'react-localize-redux'
import { connect } from 'react-redux'
import PlayersAutocomplete from './PlayersAutocomplete'
import TeamSelection from './TeamSelection'
import SaveUpdateButtons from './SaveUpdateButtons'
import { GOAL_TYPES, MATCH_HIGHLIGHT_TEAMS } from 'constants/match'

const AddEditGoal = ({
  onClose,
  handleSave,
  handleUpdate,
  existingData,
  participantsList,
  errorMinute,
  minute,
  setErrorMinute,
  resetCommonFields,
}) => {
  const [scoredTeam, setScoredTeam] = useState(
    existingData && existingData.team
      ? existingData.team
      : MATCH_HIGHLIGHT_TEAMS.own
  )
  const [p1value, setP1Value] = useState(null)
  const [p2value, setP2Value] = useState(null)
  const [goalCategory, setGoalCategory] = useState(
    existingData ? existingData.goal_category : GOAL_TYPES[0].key
  )
  const [errorGoalCategory, setErrorGoalCategory] = useState(false)
  const [resetPlayer, setResetPlayer] = useState(false)

  const resetForm = () => {
    resetCommonFields()
    setScoredTeam(MATCH_HIGHLIGHT_TEAMS.own)
    setP1Value(null)
    setP2Value(null)
    setGoalCategory(GOAL_TYPES[0].key)
    setResetPlayer(true)
  }

  const save = (exit = false) => {
    if (errorMinute || errorGoalCategory) return false

    if (!minute) {
      setErrorMinute(true)

      return false
    }
    if (!goalCategory) {
      setErrorGoalCategory(true)

      return false
    }
    const createData = {
      type: 'goal',
      team: scoredTeam,
      goal_category: goalCategory,
      minute,
      player_1: p1value,
      player_2: p2value,
    }
    handleSave(createData).then(() => {
      resetForm()
      if (exit === true) {
        onClose()
      }
    })

    return false
  }
  const update = (highLightId) => {
    if (errorMinute || errorGoalCategory) return false

    if (!goalCategory) {
      return false
    }
    const updateData = {
      type: 'goal',
      team: scoredTeam,
      goal_category: goalCategory,
      minute,
      player_1: p1value,
      player_2: p2value,
    }
    handleUpdate(highLightId, updateData)
    onClose()

    return false
  }

  const handleScoredTeam = (val) => {
    if (val === MATCH_HIGHLIGHT_TEAMS.opponent) {
      setP1Value('')
      setP2Value('')
    }
    setScoredTeam(val)
  }

  return (
    <>
      <DialogContentText>
        <Translate id="matches.highlights.enter-goal-details" />
      </DialogContentText>
      <Grid item style={{ marginTop: '0.25rem' }}>
        <TeamSelection
          selectedTeam={scoredTeam}
          handleTeam={handleScoredTeam}
        />
      </Grid>
      <Grid item>
        <FormControl
          variant="outlined"
          error={errorGoalCategory}
          margin="dense"
        >
          <InputLabel id="goal-type-select-label">
            <Translate id="matches.highlights.goal-type" />
          </InputLabel>
          <Select
            labelId="goal-type-select-label"
            id="selectbox-goal-catgory"
            value={goalCategory}
            onChange={(event) => {
              if (!(event.target.value !== '')) {
                return setErrorGoalCategory(true)
              }
              setErrorGoalCategory(false)
              setGoalCategory(event.target.value)

              return true
            }}
            margin="dense"
            label={<Translate id="matches.highlights.goal-type" />}
          >
            {GOAL_TYPES.map((p) => {
              return (
                <MenuItem key={p.key} value={p.key}>
                  {p.displayValue}
                </MenuItem>
              )
            })}
          </Select>
        </FormControl>
      </Grid>
      {scoredTeam !== MATCH_HIGHLIGHT_TEAMS.opponent && (
        <>
          <Grid item>
            <PlayersAutocomplete
              setPValue={setP1Value}
              label={<Translate id="matches.highlights.scored-by" />}
              savedPlayer={
                existingData && existingData.relationships?.player_1?.uuid
                  ? existingData.relationships.player_1.uuid
                  : 0
              }
              players={participantsList}
              resetPlayer={resetPlayer}
              setResetPlayer={setResetPlayer}
            />
          </Grid>
          <Grid item>
            <PlayersAutocomplete
              setPValue={setP2Value}
              label={<Translate id="matches.highlights.assisted-by" />}
              savedPlayer={
                existingData && existingData.relationships?.player_2?.uuid
                  ? existingData.relationships.player_2.uuid
                  : 0
              }
              players={participantsList}
              resetPlayer={resetPlayer}
              setResetPlayer={setResetPlayer}
            />
          </Grid>
        </>
      )}
      <SaveUpdateButtons
        save={save}
        existingData={existingData}
        update={update}
      />
    </>
  )
}
AddEditGoal.defaultProps = {
  onClose: () => 0,
  existingData: null,
  handleSave: () => 0,
  handleUpdate: () => 0,
}

AddEditGoal.propTypes = {
  onClose: PropTypes.func,
  handleSave: PropTypes.func,
  handleUpdate: PropTypes.func,
  participantsList: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  existingData: PropTypes.shape(),
  errorMinute: PropTypes.bool.isRequired,
  minute: PropTypes.number.isRequired,
  setErrorMinute: PropTypes.func.isRequired,
  resetCommonFields: PropTypes.func.isRequired,
}

export default connect(
  ({
    matches: {
      current: { id },
    },
  }) => ({
    matchId: id,
  }),
  {}
)(AddEditGoal)
